import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import LcaCards from "../LcaCards";
import {
  setActiveTab,
  setCity,
  setFinalProducts,
  setMonth,
  setHideSkipped,
  setTotalCount,
} from "../../../../redux/slices/LcaSlice";
import VendorCards from "./VendorCards";
import CommunityCards from "./CommunityCards";

const LcaAndBwv = ({ scrollPopupVisible }) => {
  const dispatch = useDispatch();
  const {
    activeTab,
    finalProducts,
    hideSkipped,
    bizzLca,
    bwv,
    Lca,
    finalBwv,
    selectedSubCategory,
    month,
    city,
  } = useSelector((state) => state.lcAds);

  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;
  const [carouselData, setCarouselData] = useState({
    row1: [],
    row2: [],
    row3: [],
  });
  const [needCities, setNeedCities] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const currentBwv = useSelector((state) => state.lcAds.bwv);

  const shuffleArray = (array) => {
    let shuffled = array.slice();
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const fetchData = async () => {
    const allAds = [...bizzLca, ...currentBwv];
    const row1 = allAds.filter((data) => data.bizzValue === 1);
    const row2 = allAds.filter((data) => data.bizzValue === 2);
    const row3 = allAds.filter((data) => data.bizzValue === 3);
    setCarouselData({
      row1: shuffleArray(row1),
      row2: shuffleArray(row2),
      row3: shuffleArray(row3),
    });
  };

  useEffect(() => {
    fetchData();
  }, [bizzLca, currentBwv]);

  useEffect(() => {
    const allCities = Lca.map((product) => product.placeName);
    const filteredCities = allCities.filter((city) => city && city !== "");
    const uniqueCities = [...new Set(filteredCities)];
    console.log("uniqueCities:", uniqueCities);
    if (uniqueCities.length > 0) {
      setNeedCities(uniqueCities);
    }
  }, [finalProducts]);

  const handleMonthChange = (newMonth) => {
    dispatch(setMonth(newMonth));
  };
  const typeLca = finalProducts.map((item) => ({
    ...item,
    type: "Customer",
  }));
  const typeBwv = finalBwv.map((item) => ({ ...item, type: "Vendor" }));

  const filteredLcaByCAID = [...typeLca].filter((product) => {
    return product.caIdStatus === 100;
  });
  const filteredLcaByNotCaId = [...typeLca].filter((product) => {
    return product.caIdStatus !== 100;
  });
  const filteredBWVByCAID = [...typeBwv].filter((product) => {
    return product.caIdStatus === 100;
  });
  const filteredBWVByNotCaId = [...typeBwv].filter((product) => {
    return product.caIdStatus !== 100;
  });

  const sortedLcaByDate = [...filteredLcaByNotCaId].sort((a, b) => {
    return new Date(b.updatedAt) - new Date(a.updatedAt);
  });
  const sortedBWVByDate = [...filteredBWVByNotCaId].sort((a, b) => {
    return new Date(b.updatedAt) - new Date(a.updatedAt);
  });

  // Use `Id` as the unique identifier (confirmed from console output)
  const sortedForCustomersTab = () => {
    if (selectedSubCategory?.id === 63) {
      return [...filteredLcaByCAID, ...sortedLcaByDate];
    } else {
      return [...filteredBWVByCAID, ...filteredLcaByCAID, ...sortedLcaByDate];
    }
  };

  const sortedForVendorsTab = () => {
    return [...filteredBWVByCAID, ...filteredLcaByCAID, ...sortedBWVByDate];
  };

  const combinedItems =
    activeTab === "Vendor" ? sortedForVendorsTab() : sortedForCustomersTab();

  // Debugging logs to verify deduplication
  console.log("filteredLcaByCAID:", filteredLcaByCAID);
  console.log("filteredBWVByCAID:", filteredBWVByCAID);
  console.log("sortedLcaByDate:", sortedLcaByDate);
  console.log("sortedBWVByDate:", sortedBWVByDate);
  console.log("sortedForCustomersTab:", sortedForCustomersTab());
  console.log("sortedForVendorsTab:", sortedForVendorsTab());
  console.log("combinedItems:", combinedItems);

  const totalPages = Math.ceil(combinedItems.length / usersPerPage);
  const indexOfLastItem = currentPage * usersPerPage;
  const indexOfFirstItem = indexOfLastItem - usersPerPage;
  const currentItems = combinedItems.slice(indexOfFirstItem, indexOfLastItem);

  // Split currentItems back into Customers and Vendors for rendering
  const currentUsers = currentItems.filter((item) => item.type === "Customer");
  const currentVendors = currentItems.filter((item) => item.type === "Vendor");

  useEffect(() => {
    setCurrentPage(1);
  }, [finalProducts, finalBwv]);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      paginate(currentPage - 1);
      scrollToTop();
    }
  };

  useEffect(() => {
    if (combinedItems) {
      dispatch(setTotalCount(combinedItems.length));
    }
  }, [combinedItems, finalProducts, finalBwv]);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      paginate(currentPage + 1);
      scrollToTop();
    }
  };

  const scrollToTop = () => {
    const container = document.querySelector(".hompage-ads-container");
    if (container) {
      container.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const LcaCities = () => {
    console.log(
      "LcaCities - Current city:",
      city,
      "Available cities:",
      needCities
    );
    // Ensure the current city is included in the options
    const cityOptions =
      city && !needCities.includes(city) ? [...needCities, city] : needCities;

    return (
      <FormGroup className="d-flex align-items-center gap-1">
        <Label for="city" className="fw-bold text-dark mb-0">
          City :
        </Label>
        <Input
          id="city"
          type="select"
          name="city"
          className="form-control"
          value={city || ""}
          onChange={(e) => {
            const selectedCity = e.target.value;
            console.log("City selected:", selectedCity);
            dispatch(setCity(selectedCity));
          }}
        >
          <option value="">Select City</option>
          {cityOptions.length === 0 ? (
            <option disabled>No Cities Available</option>
          ) : (
            cityOptions.map((city) => (
              <option key={city} value={city}>
                {city}
              </option>
            ))
          )}
        </Input>
      </FormGroup>
    );
  };

  // Additional debugging logs
  console.log("currentUsers:", currentUsers);
  console.log("currentVendors:", currentVendors);
  console.log("currentItems:", currentItems);

  return (
    <>
      {selectedSubCategory && selectedSubCategory.id === 63 && (
        <>
          <div
            className="col-lg-6 d-flex row mt-3 view-tabs w-100"
            style={{ marginLeft: "2px" }}
          >
            <h5
              className={`col-sm-4 ${
                activeTab === "Vendor" ? "active" : ""
              } mx-0`}
              onClick={() => {
                dispatch(setActiveTab("Vendor"));
                const searchParams = new URLSearchParams(location.search);
                searchParams.set("tab", "Vendor");
                navigate(
                  {
                    pathname: location.pathname,
                    search: searchParams.toString(),
                  },
                  { replace: true }
                );
                setCurrentPage(1);
              }}
              style={{
                textDecoration: activeTab === "Vendor" ? "underline" : "none",
                cursor: "pointer",
                width: "50%",
              }}
            >
              View Vendors
            </h5>
            <h5
              className={`col-sm-4 ${
                activeTab === "Customers" ? "active" : ""
              } mx-0`}
              onClick={() => {
                dispatch(setActiveTab("Customers"));
                const searchParams = new URLSearchParams(location.search);
                searchParams.set("tab", "Customers");
                navigate(
                  {
                    pathname: location.pathname,
                    search: searchParams.toString(),
                  },
                  { replace: true }
                );
                setCurrentPage(1);
              }}
              style={{
                textDecoration:
                  activeTab === "Customers" ? "underline" : "none",
                cursor: "pointer",
                width: "50%",
              }}
            >
              View Customers
            </h5>
          </div>
          {activeTab === "Customers" && (
            <Row className="customers-filters mx-3">
              <Col xs={12} md={4} lg={4} className="mb-1 mb-md-0">
                <LcaCities />
              </Col>
              <Col xs={12} md={6} lg={6}>
                <FormGroup className="d-flex align-items-center gap-2">
                  <Label for="month" className="fw-bold text-dark mb-0">
                    Select Month & Year:
                  </Label>
                  <Input
                    id="month"
                    type="month"
                    name="month"
                    className="form-control"
                    value={month}
                    onChange={(e) => handleMonthChange(e.target.value)}
                  />
                </FormGroup>
              </Col>
              <Col xs={12} md={2} lg={2}>
                <Button
                  className="btn btn-danger"
                  onClick={() => {
                    dispatch(setCity(""));
                    dispatch(setMonth(""));
                    setCurrentPage(1);
                    dispatch(setHideSkipped(true));
                  }}
                >
                  Clear Filters
                </Button>
              </Col>
              <Col xs={6} md={2} lg={2}>
                <Button
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#DB3545",
                    fontSize: "12px",
                  }}
                  onClick={() => {
                    dispatch(setHideSkipped(!hideSkipped));
                    setCurrentPage(1);
                  }}
                >
                  {hideSkipped ? "Show All" : "Hide Skipped "}
                </Button>
              </Col>
            </Row>
          )}
        </>
      )}
      <div>
        {activeTab === "Customers" ? (
          <CommunityCards
            allProducts={currentUsers}
            currentVendors={currentVendors}
            carouselData={carouselData}
          />
        ) : (
          <VendorCards
            carouselData={carouselData}
            allProducts={currentUsers}
            currentVendors={currentVendors}
          />
        )}
      </div>
      {(activeTab === "Customers" || activeTab === "Vendor") && (
        <div className="pagination pb-3 d-flex justify-content-center">
          <Button
            className="me-2"
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
          >
            Previous
          </Button>
          <span className="align-self-center">
            Page {currentPage} of {totalPages}
          </span>
          <Button
            className="ms-2"
            onClick={() => handleNextPage()}
            disabled={currentPage === totalPages}
          >
            Next
          </Button>
        </div>
      )}
    </>
  );
};

export default LcaAndBwv;
